<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> ตั้งค่าหน่วยสินค้า</h4>

          <div class="row mx-1 my-3">
            <b-form-input
              type="search"
              class="col"
              autofocus
              v-model="filter"
              placeholder="ค้นหาหน่วยสินค้า จากรหัส หรือชื่อหน่วย"
            ></b-form-input>
            <b-button
              class="col-5 col-sm-4 col-md-3 ml-3"
              variant="primary"
              @click="openUnitItemModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>

          <b-table
            id="unitManageTable"
            ref="unitManageTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="getUnitList"
            :fields="fields"
            :filter="filter"
            :filter-function="filterUnits"
            sort-by="creationDt"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(creationDt)="row">{{
              formatDate(row.item.creationDt)
            }}</template>

            <template v-slot:cell(buttons)="row">
              <ActionButtonGroup
                :item="row.item"
                :show-info="false"
                edit-tooltip="แก้ไขหน่วยสินค้า"
                delete-tooltip="ลบหน่วยสินค้า"
                @edit="editUnit"
                @delete="deleteUnit"
                :disabled-edit="row.item.unitStatus !== 'ACTIVE'"
                :disabled-delete="row.item.unitStatus !== 'ACTIVE'"
              />
            </template>
          </b-table>
        </div>
      </div>
      <UnitItem ref="unitItemModal"></UnitItem>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import UnitItem from "../../components/modal/ProductAndStock/UnitItem.vue";
import Dialog from "../../components/modal/Dialog.vue";
import Loading from "@/components/Loading";
import { mapGetters, mapActions } from "vuex";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";

export default {
  name: "UnitMaster",
  components: {
    UnitItem,
    Dialog,
    Loading,
    ActionButtonGroup,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "6%", padding: "16px 24px" },
          tdStyle: { width: "6%", padding: "16px 24px" },
        },
        {
          key: "unitCode",
          label: "รหัส",
          sortable: true,
          thStyle: { width: "12%", padding: "16px 24px" },
          tdStyle: { width: "12%", padding: "16px 24px" },
        },
        {
          key: "unitNameTh",
          label: "ชื่อหน่วย",
          sortable: true,
          thStyle: { width: "30%", wordBreak: "break-word" },
          tdStyle: { width: "30%", wordBreak: "break-word" },
        },
        {
          key: "unitNameEn",
          label: "ชื่อหน่วย (Eng)",
          sortable: true,
          thStyle: { width: "29%", wordBreak: "break-word" },
          tdStyle: { width: "29%", wordBreak: "break-word" },
        },
        {
          key: "creationDt",
          label: "วันที่สร้าง",
          sortable: true,
          thStyle: { width: "14%" },
          tdStyle: { width: "14%" },
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
          thStyle: { width: "9%" },
          tdStyle: { width: "9%" },
        },
      ],
      filter: "",
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getUnitList: "moduleUnitMaster/getUnitList",
    }),
  },
  methods: {
    ...mapActions({
      fetchUnitList: "moduleUnitMaster/fetchUnitList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await this.fetchUnitList({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
        });
      } catch (err) {
        this.showDialogToast("danger", "โหลดหข้อมูลไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    openUnitItemModal(unit = null) {
      this.$refs.unitItemModal.show(unit);
    },
    editUnit(unit) {
      this.openUnitItemModal(unit);
    },
    deleteUnit(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบหน่วยสินค้านี้ ?",
        "คุณต้องการลบหน่วยสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;

        this.$store
          .dispatch("moduleUnitMaster/deleteUnitItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: eventData.unitId,
          })
          .then(res => {
            if (res.status == 200) {
              this.init();
              this.showDialogToast("success", "ลบรายการหน่วยสินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการหน่วยสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    filterUnits(row, filter) {
      if (!filter || (typeof filter === "string" && !filter.trim())) {
        return true;
      }
      const s = String(filter).toLowerCase();
      const code = (row.unitCode || "").toString().toLowerCase();
      const nameTh = (row.unitNameTh || "").toString().toLowerCase();
      const nameEn = (row.unitNameEn || "").toString().toLowerCase();
      return code.includes(s) || nameTh.includes(s) || nameEn.includes(s);
    },
  },
};
</script>

<style scoped>
::v-deep #unitManageTable thead tr th,
::v-deep #unitManageTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #unitManageTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #unitManageTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}
</style>
